import ServiceGraphQL from 'src/service/gql-service';
import { customersLogEvent } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const LogCustomerEvent = ({ customerId, event, attr = {} }) => {
  const params = {
    query: customersLogEvent.QUERY,
    variables: {
      customerId,
      event,
      attr
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
